const ID = 'tooltip';

export default ID;
